/**
 * flexible.js - 移动端自适应解决方案
 *
 * 功能扩展：支持路由匹配规则，根据不同路由使用不同的 fontSize 计算方式
 *
 * 使用说明：
 * 1. 默认情况下使用原有的 flexible.js 计算规则：rem = width / 10
 * 2. 在 customRoutes 数组中添加需要使用自定义计算规则的路由路径
 * 3. 匹配到的路由将使用 setFontSize 计算规则（基于设计图宽度 920px）
 *
 * 示例：
 * - 添加路由：在第 75 行的 customRoutes 数组中添加路由路径
 *   var customRoutes = ['/veinReport', '/skinReport', '/otherRoute'];
 *
 * 自定义计算规则参数（第 84-88 行）：
 * - DESIGN_WIDTH: 设计图宽度（默认 920px）
 * - BASE_FONT_SIZE: 基准 fontSize（默认 100）
 * - MIN_FONT_SIZE: 最小 fontSize 限制（默认 50）
 * - MAX_FONT_SIZE: 最大 fontSize 限制（默认 75）
 * - MAX_WIDTH: 最大显示宽度（默认 1200）
 */
(function (win, lib) {
  var doc = win.document;
  var docEl = doc.documentElement;
  var metaEl = doc.querySelector('meta[name="viewport"]');
  var flexibleEl = doc.querySelector('meta[name="flexible"]');
  var dpr = 0;
  var scale = 0;
  var tid;
  var flexible = lib.flexible || (lib.flexible = {});

  if (metaEl) {
    console.warn('将根据已有的meta标签来设置缩放比例');
    var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
    if (match) {
      scale = parseFloat(match[1]);
      dpr = parseInt(1 / scale);
    }
  } else if (flexibleEl) {
    var content = flexibleEl.getAttribute('content');
    if (content) {
      var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
      var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
      if (initialDpr) {
        dpr = parseFloat(initialDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
      if (maximumDpr) {
        dpr = parseFloat(maximumDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
    }
  }

  if (!dpr && !scale) {
    var isAndroid = win.navigator.appVersion.match(/android/gi);
    var isIPhone = win.navigator.appVersion.match(/iphone/gi);
    var devicePixelRatio = win.devicePixelRatio;
    if (isIPhone) {
      // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
      if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
        dpr = 3;
      } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
        dpr = 2;
      } else {
        dpr = 1;
      }
    } else {
      // 其他设备下，仍旧使用1倍的方案
      dpr = 1;
    }
    scale = 1 / dpr;
  }

  docEl.setAttribute('data-dpr', dpr);
  if (!metaEl) {
    metaEl = doc.createElement('meta');
    metaEl.setAttribute('name', 'viewport');
    metaEl.setAttribute(
      'content',
      'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no'
    );
    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl);
    } else {
      var wrap = doc.createElement('div');
      wrap.appendChild(metaEl);
      doc.write(wrap.innerHTML);
    }
  }

  function refreshRem() {
    var width = docEl.getBoundingClientRect().width;

    // 路由匹配规则：需要使用新计算规则的路由列表
    var customRoutes = ['/veinReport', '/aiFAQs'];
    var currentPath = win.location.pathname;
    var useCustomCalculation = customRoutes.some(function (route) {
      return currentPath.indexOf(route) !== -1;
    });

    var rem;
    // 使用 自定义 的计算规则
    if (useCustomCalculation) {
      // 设计图宽度
      var DESIGN_WIDTH = 920;
      // 基准 fontSize（设计图下的基准值，建议100，这样设计图就是 9.2rem）
      var BASE_FONT_SIZE = 100;
      // 最小 fontSize 限制（避免在小屏幕上字体过小）
      var MIN_FONT_SIZE = 50;
      // 最大 fontSize 限制（避免在超大屏幕上字体过大）
      var MAX_FONT_SIZE = 75;
      // 最大显示宽度（PC端不再放大）
      var MAX_WIDTH = 1200;

      // 计算实际宽度（不超过最大宽度）
      var actualWidth = Math.min(width, MAX_WIDTH);

      // 计算 fontSize: 实际宽度 / 设计图宽度 * 基准fontSize
      var fontSize = (actualWidth / DESIGN_WIDTH) * BASE_FONT_SIZE;

      // 限制在最小和最大值之间
      fontSize = Math.max(MIN_FONT_SIZE, Math.min(fontSize, MAX_FONT_SIZE));
      rem = fontSize;
    } else {
      // 使用原有的 lib-flexible/flexible.js 计算规则
      if (width / dpr > 540) {
        width = 540 * dpr;
      }
      rem = width / 10;
    }

    docEl.style.fontSize = rem + 'px';
    flexible.rem = win.rem = rem;
  }

  win.addEventListener(
    'resize',
    function () {
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    },
    false
  );
  win.addEventListener(
    'pageshow',
    function (e) {
      if (e.persisted) {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
      }
    },
    false
  );

  if (doc.readyState === 'complete') {
    doc.body.style.fontSize = 12 * dpr + 'px';
  } else {
    doc.addEventListener(
      'DOMContentLoaded',
      function (e) {
        doc.body.style.fontSize = 12 * dpr + 'px';
      },
      false
    );
  }

  refreshRem();

  flexible.dpr = win.dpr = dpr;
  flexible.refreshRem = refreshRem;
  flexible.rem2px = function (d) {
    var val = parseFloat(d) * this.rem;
    if (typeof d === 'string' && d.match(/rem$/)) {
      val += 'px';
    }
    return val;
  };
  flexible.px2rem = function (d) {
    var val = parseFloat(d) / this.rem;
    if (typeof d === 'string' && d.match(/px$/)) {
      val += 'rem';
    }
    return val;
  };

  // 添加路由变化监听（用于 SPA 应用）
  // 监听 popstate 事件（浏览器前进/后退）
  win.addEventListener(
    'popstate',
    function () {
      refreshRem();
    },
    false
  );

  // 提供全局方法供 Vue Router 等调用
  win.flexibleRouteChange = function () {
    refreshRem();
  };
})(window, window['lib'] || (window['lib'] = {}));



// WEBPACK FOOTER //
// ./src/utils/flexible.js